// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Price_price__9Dzxz {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
}

.Price_price__value--blurred__vu\\+1- {
  filter: blur(0.8rem);
}
`, "",{"version":3,"sources":["webpack://./src/components/Price/Price.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".price {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.5rem;\n}\n\n.price__value--blurred {\n  filter: blur(0.8rem);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"price": `Price_price__9Dzxz`,
	"price__value--blurred": `Price_price__value--blurred__vu+1-`
};
export default ___CSS_LOADER_EXPORT___;
